<template>
  <div class="my-scenes-body">
    <div>
      <div class="my-scenes-head-box">
        <div @click="noUrl">
          <img src="@/assets/img/cj1.png" />
          <div>
            <div>
              <p>场景要素知识云</p>
              <span>场景要素寻源搜索引擎服务</span>
            </div>
            <span>立即咨询 ></span>
          </div>
        </div>
        <div @click="noUrl">
          <img src="@/assets/img/cj2.png" />
          <div>
            <div>
              <p>场景辅导服务</p>
              <span>场景申报全流程辅导服务</span>
            </div>
            <span>立即咨询 ></span>
          </div>
        </div>
      </div>
      <div class="my-scenes-filter-box">
        <div class="my-scenes-filter-tab">
          <div class="my-scenes-filter-tab-list">
            <div :class="{ active: stateCode == '' }" @click="stateCode = ''">
              全部
            </div>
            <div
              v-for="item in stateData"
              :key="item.code"
              :class="{ active: stateCode == item.code }"
              @click="stateCode = item.code"
            >
              {{ item.text }}
            </div>
          </div>
          <div class="my-scenes-filter-search">
            <a-input-search
              placeholder="请输入场景名称搜索"
              @search="searchScenes"
              v-model="searchScenesVal"
            >
              <a-icon type="search" slot="enterButton" />
            </a-input-search>
          </div>
        </div>
        <div class="my-scenes-filter-btn">
          <a-button class="btn-green" @click="scenesApply('add', '')"
            >场景申报
          </a-button>
          <a-tooltip placement="right">
            <template slot="title">
              <span>面向政企，辅助线上申报场景</span>
            </template>
            <a-icon type="info-circle" />
          </a-tooltip>
        </div>
      </div>
      <div class="my-scenes-list">
        <a-table
          :columns="columns"
          :data-source="scenesData"
          :pagination="pages"
          @change="tablePage"
        >
          <div slot="fundAmount" slot-scope="text">
            {{ (text && `￥${text}`) || "--" }}
          </div>
          <div slot="statusName" slot-scope="text, record">
            <span class="my-scenes-status">
              <i v-if="record.statusName == '预审中'" class="yus"></i>
              <i v-else-if="record.statusName == '严选中'" class="yans"></i>
              <i v-else-if="record.statusName == '待发榜'" class="fb"></i>
              <i v-else-if="record.statusName == '预审不通过'" class="btg"></i>
              <i v-else-if="record.statusName == '严选不通过'" class="btg"></i>
              <i v-else></i>
              {{ record.statusName }}
            </span>
          </div>
          <div slot="operating" slot-scope="text, record">
            <div class="my-scenes-operating">
              <span @click="taskDetail(record)">详情</span>
              <template v-if="record.status == 'SYS0101'">
                <span @click="scenesApply('edit', record)">编辑</span>
                <span @click="scenesDel(record.id)">删除</span>
              </template>
            </div>
          </div>
        </a-table>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { commonCode, getOwnCase, sceneDelete } from "@/api/scene";

const columns = [
  {
    title: "场景信息",
    dataIndex: "sceneName",
    key: "sceneName",
    ellipsis: true,
    width: 260,
  },
  {
    title: "场景领域",
    dataIndex: "fieldLevelOneName",
    key: "fieldLevelOneName",
  },
  {
    title: "应用行业",
    dataIndex: "industryLevelOneName",
    key: "industryLevelOneName",
  },
  {
    title: "类别",
    dataIndex: "skillLevelOneName",
    key: "skillLevelOneName",
  },
  {
    title: "预估成本(万元)",
    dataIndex: "fundAmount",
    key: "fundAmount",
    scopedSlots: { customRender: "fundAmount" },
    width: 160,
  },
  {
    title: "更新时间",
    dataIndex: "updateTime",
    key: "updateTime",
  },
  {
    title: "状态",
    dataIndex: "statusName",
    key: "statusName",
    scopedSlots: { customRender: "statusName" },
  },
  {
    title: "操作",
    dataIndex: "operating",
    key: "operating",
    width: 160,
    scopedSlots: { customRender: "operating" },
  },
];
export default {
  data() {
    return {
      columns,
      pages: {
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        showTotal: (total) => `共 ${total} 项`,
      },
      stateData: [],
      stateCode: "",
      scenesData: [],
      searchScenesVal: "",
      page: {
        current: 1,
        size: 10,
      },
    };
  },
  mounted() {
    this.loadGetOwnCase();
    this.loadCommonCode();
  },
  computed: mapGetters(["userInfo"]),
  watch: {
    stateCode: function (val) {
      this.loadGetOwnCase();
    },
  },
  methods: {
    noUrl(){
      this.$message.warning("暂无跳转链接！")
    },
    loadGetOwnCase() {
      let data = {
        status: this.stateCode,
        keywords: this.searchScenesVal,
      };
      getOwnCase(this.page, data).then((res) => {
        this.scenesData = res.data.records;
        this.pages.total = res.data.total;
      });
    },
    loadCommonCode() {
      let obj = {
        type: "WORKFLOW",
        precode: "SYS01",
      };
      commonCode(obj).then((res) => {
        this.stateData = res.data;
      });
    },
    searchScenes() {
      this.loadGetOwnCase();
    },
    tablePage(page) {
      this.page.current = page.current;
      this.loadGetOwnCase();
    },
    scenesDel(id) {
      let _this = this;
      this.$confirm({
        title: "您确定删除吗?删除后不可恢复！",
        onOk() {
          sceneDelete(id).then((res) => {
            _this.stateCode = "";
            _this.searchScenesVal = "";
            _this.page.current = 1;
            _this.loadGetOwnCase();
          });
        },
        onCancel() {},
      });
    },
    scenesApply(type, val) {
      if (this.userInfo.company.status !== "3") {
        this.$message.warn(
          (this.userInfo.company.companyType === "1" ? "政府组织" : "企业") +
            "未认证，不能申报！"
        );
        return;
      }
      this.$router.push({
        name: "myScenesApply",
        params: {
          type,
          info: val,
        },
      });
    },
    taskDetail(val) {
      this.$router.push({
        name: "myScenesDetail",
        params: {
          info: val,
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.my-scenes-body {
  background: #f5f5f5;
  padding: 24px;
  height: 100%;
  overflow-y: auto;

  > div {
    width: 1240px;
    margin: 0 auto;
  }

  .my-scenes-head-box {
    display: flex;

    > div {
      position: relative;
      width: 280px;
      height: 80px;
      margin-right: 16px;

      > img {
        width: 100%;
        height: 100%;
      }

      > div {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 2;
        padding: 20px 15px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        > div {
          > p {
            text-shadow: 2px 2px 2px rgba(0, 0, 0, 0.24);
            font-size: 18px;
            line-height: 20px;
            margin-bottom: 8px;
            color: #fff;
          }

          > span {
            font-size: 12px;
            display: block;
            line-height: 12px;
            color: #fff;
          }
        }

        > span {
          height: 24px;
          border: 1px solid #ffffff;
          line-height: 22px;
          padding: 0 10px;
          color: #fff;
          font-size: 12px;
          cursor: pointer;
        }
      }
    }
  }

  .my-scenes-filter-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 24px;

    .my-scenes-filter-tab {
      display: flex;
      align-items: center;

      .my-scenes-filter-tab-list {
        display: flex;

        > div {
          width: 96px;
          height: 32px;
          background: #fff;
          border: 1px solid #d9d9d9;
          text-align: center;
          line-height: 32px;
          cursor: pointer;

          &.active {
            color: #1abc9c;
            border-color: #1abc9c;
          }
        }
      }

      .my-scenes-filter-search {
        margin-left: 24px;
        border: 1px solid #d9d9d9;
        border-radius: 2px;
        overflow: hidden;
      }
    }

    .my-scenes-filter-btn {
      display: flex;
      align-items: center;

      > button {
        margin-right: 16px;
      }

      > i {
        color: #8c8c8c;
      }
    }
  }

  .my-scenes-list {
    background: #fff;
    margin-top: 24px;

    .my-scenes-status {
      display: flex;
      align-items: center;

      > i {
        width: 6px;
        height: 6px;
        background: #bfbfbf;
        border-radius: 50%;
        margin-right: 8px;

        &.yus {
          background: #faad14;
        }

        &.yans {
          background: #52c41a;
        }

        &.fb {
          background: #1890ff;
        }

        &.btg {
          background: #ff4d4f;
        }
      }
    }

    .my-scenes-operating {
      display: flex;

      > span {
        cursor: pointer;
        color: #1abc9c;
        margin-right: 20px;
        white-space: nowrap;

        &:last-child {
          margin-right: 0;
        }
      }
    }
  }
}
</style>
<style>
.my-scenes-filter-search input {
  width: 280px !important;
  height: 32px;
  background: #ffffff;
  border: none;
  border-radius: 2px;
}

.my-scenes-filter-search button {
  background: #d9d9d9 !important;
  border-color: #d9d9d9 !important;
  color: #8c8c8c !important;
  box-shadow: none;
  border-radius: 0;
}

.my-scenes-list th,
.my-scenes-list td {
  border-color: #f0f0f0 !important;
}

.ant-table-pagination.ant-pagination {
  margin: 16px;
}
</style>
